import { t } from "../i18n"
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "submitButton" ]

  connect() {
    console.log("Form submission controller connected")
  }

  submit(event) {
    console.log("Submit handler called", this.hasSubmitButtonTarget)

    if (!this.hasSubmitButtonTarget) return

    // Store original text
    this.originalText = this.submitButtonTarget.value || this.submitButtonTarget.innerHTML

    // Disable and show loading state
    this.submitButtonTarget.disabled = true

    // Handle both input type="submit" and button elements
    if (this.submitButtonTarget.tagName === 'INPUT') {
      this.submitButtonTarget.value = t("javascript.controllers.form_submission_controller.saving")
    } else {
      this.submitButtonTarget.innerHTML = `
        <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white inline-block" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        ${t("javascript.controllers.form_submission_controller.saving")}
      `
    }

    // The button will be automatically reset when Turbo replaces the form
    // No need for manual reset since the entire form gets replaced
  }
}
